// extracted by mini-css-extract-plugin
export default {"tbl":"src_tbl__U9iSO","caption":"src_caption__bVs9h","tblHead":"src_tblHead__Pusif","tdLabels":"src_tdLabels__FrDoz","tdReview":"src_tdReview__ZfYns"};